<template>
	<div class="shop_con">
		<div class="shop_view">
			<!-- 轮播图 -->
			<div class="">
				<swipeItem :swipeList="swipeList" :height="height" bRadius="0px"></swipeItem>
			</div>
			<!-- 分类 -->
			<navList :navList="navList" @getItem="getItem"></navList>
      <!-- <Nav v-else :navList="navList" @getItem="getItem"></Nav> -->
		</div>

		<div class="padd_shop pr flex">
			<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="finishedtext"
				@load="initListData"
				:immediate-check="false"
			>
			 <div class="flex flex-wrap">
				  <div>
						<div class="every_shop_con" v-for="(item,index) in list1" :key="index" @click="getdDetail(item.id)" >
						<van-image :src="item.goods_picture" :class="{height: errorImg1.indexOf(index) != -1 }" :lazy-load="true" @error="error1(index)">
							<template v-slot:error>
								<img class="wh_36 b-radius-6" src="../../assets/img/icon/error.png" alt="">
							</template>
						</van-image>
						<div class="every_shop_bottom">
							<div class="shop_txt">{{item.goods_title}}</div>
							<div class="flexs flex-jus">
								<div class="shop_fen">{{item.transaction_integral}}积分</div>
								<div class="shop_num">已兑{{item.transaction_number}}件</div>
							</div>
						</div>
					</div>
					</div>
					<div class="list2">
						<div class="every_shop_con" v-for="(item,index) in list2" :key="index" @click="getdDetail(item.id)">
						<van-image :src="item.goods_picture" :class="{height: errorImg2.indexOf(index) != -1 }" :lazy-load="true" @error="error2(index)">
							<template v-slot:error>
								<img class="wh_36 b-radius-6" src="../../assets/img/icon/error.png" alt="">
							</template>
						</van-image>

						<div class="every_shop_bottom">
							<div class="shop_txt">{{item.goods_title}}</div>
							<div class="flexs flex-jus">
								<div class="shop_fen">{{item.transaction_integral}}积分</div>
								<div class="shop_num">已兑{{item.transaction_number}}件</div>
							</div>
						</div>
					</div>
					</div>
			 </div>
			
			</van-list>
	    
  </div>
	<noData v-if="show" top="60%"></noData>
	<loading :loadFlag="loadFlag" :class="{ 'top60': flag }"></loading>
	</div>
</template>
<script>
  import { getAdvertising, goodsType, goodsLists } from '@/api/api.js'
  import swipeItem from '@/components/swipeItem'
  import navList from '@/components/navList'
  import Nav from '@/components/nav'
	import noData from "@/components/noData"
	import loading from "@/components/loading"
	import { getList } from '@/utils/common'
	import { getCode } from '@/utils/wx'
	export default {
		components: {
			swipeItem,
      navList,
			Nav,
			noData,
			loading
		},
		data() {
			return {
        swipeList: [],
				navList: [],
				list1: [],
				list2: [],
        page: 1,
				loading: false,
				finishedtext: '',
				shop_type_id: '',
				finished: false,
				show: false,
				flag: false,
				enterIn: false,
				errorImg1: [],
				errorImg2: [],
				loadFlag: false,
				flag: false,
				height: ''
			};
		},
		computed: {

      itemWidth() {
        return (160 * (document.documentElement.clientWidth / 375)) 
        //rem布局 计算列宽度
        //可以根据自己的rem设置修改这里的 334 值
      },
      gutterWidth() {
        return (15 * (document.documentElement.clientWidth / 375)) 
        //rem布局 计算x轴方向margin(y轴方向的margin自定义在css中即可)
        //可以根据自己的rem设置修改这里的 36 值
      },

    },
		created() {
			const searchParams = new URLSearchParams(window.location.search)
    	const urlCode = searchParams.get('code')
			if(urlCode){
        getCode().then(()=>{
          this.initData()
				}).catch(()=>{})
			} else {
        this.initData()
			}
      
		},
		mounted(){
      this.height = (document.documentElement.clientWidth / 375) * 175 + 'px'
		},
		methods: {
			async initData(){
				this.loadFlag = true
        const res = await getAdvertising({ type: 1 })
				
				if(res.code == 1000){
					this.swipeList = res.data
				}else {
					 this.$toast(res.msg)
				}

				const classres = await goodsType()
				this.loadFlag = false
				if(classres.code == 1000){
					this.navList = classres.data
					this.shop_type_id = this.navList[0] && this.navList[0].id? this.navList[0].id:''
					this.initListData(this.shop_type_id)
				}else {
					 this.$toast(res.msg)
				}
			},
			initListData(){
				if(this.shop_type_id){
          getList(this, goodsLists, {shop_type_id: this.shop_type_id, page: this.page }, 'shop',3)
				}
				
				
			},
			getItem(obj){
				this.flag = true
        this.finishedtext = ''
        this.loading = false
        this.finished = false
        this.show = false
        this.shop_type_id = obj.item.id
        this.page = 1
        this.list1 = []
        this.list2 = []
				this.initListData()
			},

			getdDetail(id){
				getCode().then(()=>{
          this.$router.push({ path: '/shopdetail', query: { id } })
				}).catch(()=>{})
        
      },
			error2(index){
				this.errorImg2.push(index)
			},
			error1(index){
        this.errorImg1.push(index)
			}
		}
	}
</script>
<style lang="less" scoped>
	.shop_con {
		padding-top: 238px;
	}
	.shop_view {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		height: 238px;
		background: #FFFFFF;
		z-index: 30;
		padding-top: 15px;
		box-sizing: border-box
	}
	.padd_shop {
  padding: 16px 20px 0;

  .every_shop_con {
    width: 160px;
    margin-right: 15px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.06), 0px 3px 8px 0px rgba(0, 0, 0, 0.02);
    border-radius: 6px;
    margin-bottom: 16px;

    &:last-child{
      margin-bottom: 0;
    }

    

    /deep/.van-image {
      width: 100%;
      border-radius: 6px 6px 0 0;
    }

		/deep/.van-image__img {
			border-radius: 6px 6px 0 0;
		}

    .every_shop_bottom {
      padding: 10px 10px 15px;
      border-radius: 0 0 6px 6px;

      .shop_txt {
        width: 100%;
        font-size: 13px;
        font-weight: 500;
        color: #313131;
        text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin-bottom: 10px;
      }

      .shop_fen {
        height: 15px;
        font-size: 15px;
        font-weight: 600;
        color: #FF562F;
        line-height: 15px;
        text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.06);
      }

      .shop_num {
        font-size: 11px;
        color: #636363;
        text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.06);
      }
    }
  }

}

/deep/.van-list__finished-text {
	padding-top: 10px;
	line-height: 20px !important;
}
/deep/.van-list__loading {
	display: none;
}

.list2 .every_shop_con {
	margin-right: 0 !important;
}

.height {
	height: 160px;
}

.top60 {
	top: 60% !important;
}
</style>
